import TypeScreen, { typescreenManager } from "./TypeScreen"

export default TypeScreen
export { typescreenManager }
